export enum DOC_TYPE {
    SELFIE = "SELFIE",
    PAN = "PAN",
    AADHAAR = "AADHAAR",
    PAY_SLIP_1 = "PAY_SLIP_1",
    RENTAL_AGREEMENT = "RENTAL_AGREEMENT",
    OFFER_LETTER = "OFFER_LETTER",
    CURRENT_ADDRESS_PROOF = "CURRENT_ADDRESS_PROOF",
    BANK_STMT = "BANK_STMT",
    CUST_SIGNATURE = "CUST_SIGNATURE",
    OTHER = "OTHER",
}

export enum ANDROID_UPLOAD_TYPE {
    CAMERA = "CAMERA",
    DOCUMENT = "DOCUMENT",
    FILE_CHOOSER = "FILE_CHOOSER",
    CONTACT_REFERENCE = "CONTACT_REFERENCE",
    LOCATION = "LOCATION",
    SMS = "SMS",
    OTHERS = "OTHERS",
}
export enum UPLOAD_SIDE {
    FRONT = "FRONT",
    BACK = "BACK",
    SINGLE = "SINGLE",
}
export const iconName = (type: string) => {
    if (type === DOC_TYPE.SELFIE || type === DOC_TYPE.PAN) {
        return "fa fa-camera";
    } else {
        return "fa fa-upload";
    }
};

export const currentAddressProofOptions = [
    {
        name: "Select type",
        value: "",
    },
    {
        name: "Driving License",
        value: "DL",
    },
    {
        name: "Aadhaar",
        value: "AADHAAR",
    },
    {
        name: "Voter Id",
        value: "VOTER_ID",
    },
    {
        name: "Passport",
        value: "PASSPORT",
    },
];
